import { Box, Grid } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";

const StrategicAlliances = () => {
  return (
    <Grid container sx={design.Container}>
      <Grid size={{ xs: 1, md: 1.5 }} />

      <Grid size={{ xs: 10, md: 9 }} py={2}>
        <CustomText
          color="#215DA6"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          width="100%"
          sx={design.Title}
        >
          Nuestras Alianzas
        </CustomText>
        <Box sx={design.Line} />
        <Grid container spacing={2} mt={2}>
          {/* CARD IZQUIERDA */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={design.Card("#00518c", "#b0c9db8b")}>
              <Box sx={design.Header}>
                <Box flex={1}>
                  <ImageLoader
                    src="https://dulab.com.mx/assets/dulab-logo-sUMgtMu4.png"
                    width={210}
                    height={78}
                  />
                </Box>
                <Box sx={design.BadgeLab}>Laboratorio</Box>
              </Box>
              <CustomText
                color="#000"
                fontWeight={400}
                fontFamily="Nunito"
                textAlign="justify"
                width="99%"
                sx={design.Description}
              >
                Nos aliamos con uno de los laboratorios más prestigiosos del
                país para garantizar diagnósticos confiables respaldados por
                tecnología de vanguardia y un equipo altamente capacitado.
              </CustomText>
              <CustomText
                color="#8893A5"
                fontWeight={500}
                fontFamily="Nunito"
                textAlign="left"
                width="100%"
                style={design.SectionTitle}
              >
                SERVICIOS EN MEDAM
              </CustomText>
              <Grid container spacing={1} mt={2}>
                <Grid size={6}>
                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Laboratorio 24h
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Tomografía
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Mastografía
                    </CustomText>
                  </Box>
                </Grid>

                <Grid size={6}>
                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Rayos X
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Ultrasonido
                    </CustomText>
                  </Box>

                  <Box sx={design.Service}>
                    <FiberManualRecordIcon sx={design.Dot} />
                    <CustomText
                      color="#000"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="justify"
                      width="99%"
                      sx={design.Font}
                    >
                      Resonancia
                    </CustomText>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* CARD DERECHA */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={design.Card("#35b32e", "#47903c4f")}>
              <Box sx={design.Header}>
                <Box flex={1}>
                  <ImageLoader
                    src="https://dulab.com.mx/assets/MoviCare-C4zsWL9o.png"
                    width={310}
                    height={70}
                  />
                </Box>
                <Box sx={design.BadgeDom}>Domicilio</Box>
              </Box>
              <CustomText
                color="#000"
                fontWeight={400}
                fontFamily="Nunito"
                textAlign="justify"
                width="100%"
                sx={design.Description}
              >
                Nuestra alianza extiende la atención médica integral hasta la
                puerta de tu casa, facilitando servicios dignos y accesibles con
                la misma visión de excelencia que nos caracteriza.
              </CustomText>
              <CustomText
                color="#8893A5"
                fontWeight={500}
                fontFamily="Nunito"
                textAlign="left"
                width="100%"
                style={design.SectionTitle}
              >
                ATENCIÓN ESPECIALIZADA
              </CustomText>
              <Box sx={design.CheckItem}>
                <CheckRoundedIcon sx={design.CheckIcon} />
                <CustomText
                  color="#000"
                  fontWeight={400}
                  fontFamily="Nunito"
                  textAlign="justify"
                  width="99%"
                  sx={design.Font}
                >
                  Estudios de laboratorio clínico a domicilio
                </CustomText>
              </Box>
              <Box sx={design.CheckItem}>
                <CheckRoundedIcon sx={design.CheckIcon} />
                <CustomText
                  color="#000"
                  fontWeight={400}
                  fontFamily="Nunito"
                  textAlign="justify"
                  width="99%"
                  sx={design.Font}
                >
                  Servicios de Rayos X en casa
                </CustomText>
              </Box>
              <Box sx={design.CheckItem}>
                <CheckRoundedIcon sx={design.CheckIcon} />
                <CustomText
                  color="#000"
                  fontWeight={400}
                  fontFamily="Nunito"
                  textAlign="justify"
                  width="99%"
                  sx={design.Font}
                >
                  Traslados en ambulancia equipada
                </CustomText>
              </Box>
              <Box sx={design.CheckItem}>
                <CheckRoundedIcon sx={design.CheckIcon} />
                <CustomText
                  color="#000"
                  fontWeight={400}
                  fontFamily="Nunito"
                  textAlign="justify"
                  width="99%"
                  sx={design.Font}
                >
                  Atención exclusiva para pacientes con movilidad reducida
                </CustomText>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box sx={design.FooterLine} />

        <CustomText sx={design.FooterText}>
          Comprometidos con tu salud a través de colaboraciones líderes en el
          sector médico.
        </CustomText>
      </Grid>

      <Grid size={{ xs: 1, md: 1.5 }} />
    </Grid>
  );
};

export default StrategicAlliances;

const design = {
  Container: {
    background: "#FFFFFF",
  },
  Title: {
    fontSize: {
      xs: 34,
      md: 46,
    },
    mt: 1,
  },
  Line: {
    width: 70,
    height: 4,
    background: "#0A56D8",
    borderRadius: 10,
    mx: "auto",
  },
  Card: (color, boxS) => ({
    background: "#FFF",
    borderRadius: "20px",
    padding: "20px",
    // boxShadow: `20px 20px 35px 0px ${boxS}`,
    height: "40vh",
    transition: ".35s",
    border: `1px solid ${color}`,
    "&:hover": {
      border: `1px solid ${color}`,
      transform: "translateY(-5px)",
      boxShadow: `20px 20px 35px 0px ${boxS}`,
    },
  }),

  Header: {
    display: "flex",
    alignItems: "center",
    mb: 3,
  },
  Font: {
    fontSize: 13,
  },

  IconContainer: {
    width: 62,
    height: 62,
    borderRadius: "18px",
    background: "#F5F8FD",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },

  BadgeDom: {
    borderRadius: "30px",
    padding: "5px 14px",
    fontWeight: 700,
    fontSize: 14,
    fontFamily: "Nunito",
    color: "#63b32e",
    background: "#EAFBF2",
  },
  BadgeLab: {
    borderRadius: "30px",
    padding: "5px 14px",
    fontWeight: 700,
    fontSize: 14,
    color: "#00579c",
    background: "#EEF4FF",
    fontFamily: "Nunito",
  },

  Description: {
    lineHeight: 1.8,
    fontSize: 15,
    mb: 2,
  },

  SectionTitle: {
    fontSize: 12,
    letterSpacing: "2px",
  },

  Service: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 1.5,
    fontSize: 15,
  },

  Dot: {
    fontSize: 8,
    color: "#00579c",
  },

  CheckItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
    mb: 2,
    mt: 2,
  },

  CheckIcon: {
    color: "#63b32e",
    fontSize: 18,
    mt: "2px",
  },

  FooterLine: {
    width: "100%",
    height: 1,
    // background: "#E5E8ED",
    mt: 7,
    mb: 3,
  },

  FooterText: {
    textAlign: "center",
    color: "#7D8795",
    fontStyle: "italic",
    fontSize: 15,
    fontFamily: "Nunito",
  },
};
